import React, { useRef } from 'react';
import { TextAlignment, DisplayAlignment } from '../../../enum/EnumRepository';
import { StyledTextAreaComponent } from '../../../dto/StyleCompRepository';


export interface HeadlessTextAreaProps {
  alignment: TextAlignment;
  content: string;
  placeholder?: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  StyledTextArea: StyledTextAreaComponent
  $minRows?: number;
  $maxRows?: number;
  rows?: number;
}

export type Alignment = TextAlignment | DisplayAlignment;


const HeadlessTextArea: React.FC<HeadlessTextAreaProps> = ({
  alignment,
  content,
  placeholder,
  handleChange,
  handleKeyDown,
  StyledTextArea,
  $minRows = 1,
  $maxRows = 5,
  rows,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <StyledTextArea
      ref={textareaRef}
      $alignment={alignment}
      value={content}
      placeholder={placeholder}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      rows={rows}
      minRows={$minRows}
      maxRows={$maxRows}
    />
  );
}


export default HeadlessTextArea;